if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.details = this.querySelector('details');
        this.nativeButton = this.querySelector('button'); // hidden native share button
        this.summary = this.querySelector('summary');

        this.urlToShare = document.location.href;

        // 👉 If Web Share API supported
        if (navigator.share && this.nativeButton) {
          // hide fallback details
          if (this.details) this.details.setAttribute('hidden', '');

          // show native button
          this.nativeButton.classList.remove('hidden');

          this.nativeButton.addEventListener('click', () => {
            navigator.share({
              title: document.title,
              url: this.urlToShare,
            });
          });
        }

        // 👉 Optional: reset details when closed
        if (this.details) {
          this.details.addEventListener('toggle', () => {
            if (!this.details.open && this.summary) {
              this.summary.focus();
            }
          });
        }
      }

      // 👉 keep support if Shopify updates URL dynamically
      updateUrl(url) {
        this.urlToShare = url;
      }
    }
  );
}
